import { installGermanMessages } from '@konvoi/shared';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { beobachteSichtfeld } from './lib/sichtfeld.js';
import { applyTheme, currentTheme, watchSystemTheme } from './lib/theme.js';
import './styles.css';

// Alle Prüfmeldungen auf Deutsch — auch die, die aus dem Protokoll kommen.
installGermanMessages();

// Die gemerkte Wahl der Darstellung gilt ab der ersten gezeichneten Bildzeile.
applyTheme(currentTheme());
watchSystemTheme();

// Die Höhe der Hülle kommt aus der Messung, nicht aus 100dvh — siehe lib/sichtfeld.ts.
beobachteSichtfeld();

const wurzel = document.getElementById('app');
if (wurzel === null) {
  throw new Error('Der Einhängepunkt der Anwendung fehlt.');
}

createRoot(wurzel).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
